import React from 'react';
import { CheckIcon } from 'lucide-react';
interface EstimateButtonProps {
  onApply: () => void;
  /** True once this screen's figure came from the estimate rather than typing. */
  applied: boolean;
  /** Shown instead of the button when there is nothing to base an estimate on. */
  unavailableReason?: string;
}

/**
 * "Not sure — use a typical estimate" for the money screens.
 *
 * The mousedown guard matters more than it looks: these buttons sit directly
 * beneath an autofocused input, so on a phone the first tap would otherwise be
 * swallowed dismissing the keyboard and the estimate would appear not to work.
 * Preventing the default mousedown stops the button stealing focus, so the very
 * first tap applies the figure.
 */
export function EstimateButton({
  onApply,
  applied,
  unavailableReason
}: EstimateButtonProps) {
  if (unavailableReason) {
    return <p className="mt-4 text-sm text-slate-500 dark:text-slate-400 leading-relaxed" data-id="element-203" data-mp="jcd2wqakd7om">
        {unavailableReason}
      </p>;
  }
  return <button type="button" onMouseDown={event => event.preventDefault()} onClick={onApply} aria-pressed={applied} className={`mt-4 inline-flex items-center justify-center gap-2 w-full px-5 py-4 rounded-xl border text-base font-medium transition-colors ${applied ? 'border-primary-500 bg-primary-50 dark:bg-primary-500/10 text-primary-700 dark:text-primary-300' : 'border-slate-200 dark:border-white/10 text-slate-600 dark:text-slate-300 hover:border-primary-400'}`} data-id="element-204" data-mp="1c5h2k22svgef">
      {applied && <CheckIcon className="w-5 h-5" data-id="element-205" data-mp="24t33t3ok28y4" />}
      {applied ? 'Typical estimate applied' : 'Not sure — use a typical estimate'}
    </button>;
}